import React, { useEffect, useState } from 'react';
import './App.css';

function UsersPage() {
  // A simple local profile for the currently "logged in" user (placeholder)
  const [profile, setProfile] = useState({
    name: 'Your Name',
    city: 'Your City',
    favGenre: 'Your Favorite Genre'
  });

  const [collection, setCollection] = useState([]);
  const [newBook, setNewBook] = useState('');

  // Load from localStorage
  useEffect(() => {
    try {
      const savedProfile = localStorage.getItem('my_profile');
      const savedCollection = localStorage.getItem('my_collection');
      if (savedProfile) setProfile(JSON.parse(savedProfile));
      if (savedCollection) setCollection(JSON.parse(savedCollection));
    } catch {}
  }, []);

  // Persist to localStorage
  useEffect(() => {
    try { localStorage.setItem('my_profile', JSON.stringify(profile)); } catch {}
  }, [profile]);
  useEffect(() => {
    try { localStorage.setItem('my_collection', JSON.stringify(collection)); } catch {}
  }, [collection]);

  const addBook = () => {
    const title = newBook.trim();
    if (!title) return;
    setCollection(prev => [...prev, { id: Date.now(), title }]);
    setNewBook('');
  };

  const removeBook = (id) => {
    setCollection(prev => prev.filter(b => b.id !== id));
  };

  return (
    <div className="container">
      <div className="header">
        <h1 className="title">My Profile</h1>
        <p className="subtitle">Your personal book club space</p>
      </div>

      <div className="details-grid">
        <div className="detail-card">
          <span className="detail-label">👤 Name</span>
          <input
            className="input-inline"
            value={profile.name}
            onChange={(e) => setProfile({ ...profile, name: e.target.value })}
            placeholder="Your Name"
          />
        </div>
        <div className="detail-card">
          <span className="detail-label">🏙️ City</span>
          <input
            className="input-inline"
            value={profile.city}
            onChange={(e) => setProfile({ ...profile, city: e.target.value })}
            placeholder="Your City"
          />
        </div>
        <div className="detail-card">
          <span className="detail-label">📚 Favorite Genre</span>
          <input
            className="input-inline"
            value={profile.favGenre}
            onChange={(e) => setProfile({ ...profile, favGenre: e.target.value })}
            placeholder="Your Favorite Genre"
          />
        </div>

        <div className="detail-card detail-wide">
          <span className="detail-label">📖 My Collection</span>
          <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
            <input
              className="input-inline"
              value={newBook}
              onChange={(e) => setNewBook(e.target.value)}
              placeholder="Add a book title"
            />
            <button className="toggle" type="button" onClick={addBook}>Add</button>
          </div>
          {collection.length === 0 ? (
            <p className="detail-value" style={{ margin: 0 }}>No books yet. Add your first!</p>
          ) : (
            <ul style={{ margin: 0, paddingLeft: 18 }}>
              {collection.map(b => (
                <li key={b.id} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                  <span className="detail-value" style={{ flex: 1 }}>{b.title}</span>
                  <button className="toggle" type="button" onClick={() => removeBook(b.id)}>Remove</button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

export default UsersPage;


